// VIBRANIAM-SPACE v2 - fotostrobo.js
// Fotostrobo preset library: reads a manifest of Christian Brogi images.
// The folder path is ALWAYS relative to the site root ("./fotostrobo/"), so
// it resolves identically from a local server and from a deployed domain.

export const FOTOSTROBO_DIR = './fotostrobo/';
export const FOTOSTROBO_MANIFEST = './fotostrobo/fotostrobo-manifest.json';

let cachedManifest = null;

/** Loads the fotostrobo manifest once. Returns { images: [{ filename, weight, credit }] }. */
export async function loadFotostroboManifest() {
  if (cachedManifest) return cachedManifest;
  let raw = null;
  try {
    const res = await fetch(FOTOSTROBO_MANIFEST);
    if (res.ok) raw = await res.json();
  } catch {
    raw = null;
  }
  if (!raw || !Array.isArray(raw.images)) {
    cachedManifest = { images: [] };
    return cachedManifest;
  }
  cachedManifest = {
    images: raw.images
      .filter((i) => i && typeof i.filename === 'string')
      .map((i) => ({
        filename: i.filename,
        url: `${FOTOSTROBO_DIR}${i.filename}`,
        weight: Math.max(1, Math.floor(Number(i.weight) || 1)),
        credit: i.credit || 'Christian Brogi',
      })),
  };
  return cachedManifest;
}
